/**
 * The Cryptico mark, inlined from design/docs/logo/svg/cryptico-mark-mono.svg.
 *
 * Inlined rather than referenced as an <img> so the path can keep `currentColor`: the mark
 * then follows the accent of whichever theme is active — blue in light, purple in dark —
 * without shipping two files or a theme-aware <picture>.
 */
export function Mark({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 74 90"
      role="img"
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M72.766 17.057A40 40 0 1 0 72.766 62.943A6 6 0 0 0 62.936 56.06A28 28 0 1 1 62.936 23.94A6 6 0 0 0 72.766 17.057ZM14 64C13 72 9 80 4 85C1 88 2 92 6 92C13 89 22 85 29 82C32 81 33 78 30 75L21 69C18 67 16 65 14 64ZM33.4 41A4.4 4.4 0 1 0 24.6 41A4.4 4.4 0 1 0 33.4 41ZM44.4 41A4.4 4.4 0 1 0 35.6 41A4.4 4.4 0 1 0 44.4 41ZM55.4 41A4.4 4.4 0 1 0 46.6 41A4.4 4.4 0 1 0 55.4 41Z"
      />
    </svg>
  );
}
